import { Box, Container, Typography, Stack, Link, Divider } from "@mui/material"
import { useIsMobile } from '@/hooks/Responsive'
import { useLang } from '@/i18n/useLang'

export default function Platform() {
  const { isMobile } = useIsMobile()
  const lang = useLang()

  return (
    <Box>
      <Container maxWidth="xl" disableGutters>
        <Stack
          direction={isMobile ? 'column' : 'row'}
          justifyContent="space-between"
          sx={{ mb: isMobile ? 6 : 8 }}
        >
          <Typography variant={isMobile ? 'h3' : 'h1'} sx={{ letterSpacing: '-0.04em', lineHeight: '1.3' }}>
            현실보다 생생한<br />
            배움의 시작
          </Typography>
        </Stack>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            paddingTop: '56.25%',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <Box
            component="iframe"
            src="https://www.youtube.com/embed/VhBUvicxmXY?si=3-tVY2AfluCi_hwb"
            title="가상실험실습학습콘텐츠 공유플랫폼 구축 사업 설명회 및 학습콘텐츠 제작표준(안) 마련을 위한 공청회 영상"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
          />
        </Box>
        {/* 제목 */}
        <Typography variant={isMobile ? 'subtitle2' : 'subtitle1'} fontWeight={700} sx={{ mt: 6, mb: 4 }} >
          가상실험실습학습콘텐츠 공유플랫폼 구축 사업 설명회 및 학습콘텐츠 제작표준(안) 마련을 위한 공청회
        </Typography>

        <Divider sx={{ mb: 6 }} />

        {/* 메타 정보 */}
        <Stack
          component="ul"
          sx={{
            p: 0,
            m: 0,
            mb: 3,
            gap: 0.5,
            listStyle: 'none',
            '& li': {
              position: 'relative',
              paddingLeft: '1em',
            },
            '& li::before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: '8px',
              width: '4px',
              height: '4px',
              borderRadius: '50%',
              bgcolor: 'grey.600',
            },
          }}
        >
          <Typography component="li">일시: 2025년 9월 18일(목) 10:30~12:30</Typography>
          <Typography component="li">장소: 서울 코엑스 A홀, Edtech ARENA 2(S07)</Typography>
          <Typography component="li">주최: 한국방송통신대학교 OpenVLab 구축사업단</Typography>
        </Stack>

        {/* 본문 */}
        <Stack spacing={1.5} sx={{ mb: 4 }}>
          <Typography>
            방송대 OpenVLab구축 사업단은 2025년 9월 강남구 코엑스에서 열린 "2025 에듀테크 코리아페어"에 참가하여 가상실험실습 학습 콘텐츠 공유 플랫폼 구축 사업에 대한 홍보 및 학습콘텐츠 제작표준(안) 마련을 위한 공청회를 진행했습니다.
          </Typography>

          <Typography>
            별도 공간에 마련된 홍보부스에서는 관람객들이 가상실험실습을 체험해볼 수 있도록 하고, 공청회를 통하여 효율적이고 활용도 높은 가상실험실 습 학습 콘텐츠 제작 표준을 제작 하기 위한 교육 및 산업계 관계자들의 의견을 수렴했습니다. <br />
            방송대 이병래 부총장(사업단장)은 "참석자들의 다양한 제언이 가상실험실습 학습콘텐츠 제작 및 공유 플랫폼 활성화의 기반을 다지는 첫걸음 이 되기를 기대한다" 라고 인사말을 전했습니다.
          </Typography>
        </Stack>

        {/* 출처 */}
        <Typography variant="body2" color="text.secondary">
          출처:{' '}
          <Link
            href="https://weekly.knou.ac.kr/articles/view.do?artcUn=5963"
            target="_blank"
            title="새 창 열림"
            rel="noopener"
          >
            https://weekly.knou.ac.kr/articles/view.do?artcUn=5963
          </Link>
        </Typography>
        
        <Divider sx={{ mt: 6 }} />
      </Container>
    </Box>
  )
}
